import reducedIndividualPersonValidationSchema from "../../utils/validation/reducedIndividualPersonValidationSchema";
import { initialIndividualState } from "../initialState/commonInitialState/individualInitialState";
import { initialReducedIndividualState } from "../initialState/commonInitialState/initialReducedIndividualState";
import { ManagerType, ManagerTypeWithQualite, ReducedManagerTypeWithQuality } from "./commonTypes/managerType";
import { 
    BusinessTransferDeed,
    oppositionLocationAddress,
    RegistrationDetails,
    TaxOfficeRegistration
} from "./objectType";

// acte de cession de fonds
export const initialBusinessTransferState: BusinessTransferDeed = {
    transferType: "acte sous seing privé",
    transferDate: "",
    signingLocation: ""
}

// enregistrement du service des impôts
export const initialTaxOfficeRegistrationState: TaxOfficeRegistration = {
    service: "Service des impôts des entreprises (SIE)",
    city: ""
}

// mention enregistration
export const initialRegistrationDetailsState: RegistrationDetails = {
    registrationNumberType: "",
    date: ""
}

// gérant
export const initialManagerState: ManagerType = {
    person: "Personne physique",
    personDetails: initialIndividualState
}

// gérant avec qualite
export const initialManagerStatewithqualities: ManagerTypeWithQualite = {
    person: "Personne physique",
    personDetails: initialIndividualState,
    qualite: ""
}


// gérant avec qualité et réduit
export const initialReducedManagerTypeWithQualityState: ReducedManagerTypeWithQuality ={
    person: "Personne physique",
    personDetails: initialReducedIndividualState,
    qualite: "Gérant"
}


// liste gérants
export const initialManagerListState: ManagerType[] = [ initialManagerState ]
export const initialManagerListStatewithQualities: ManagerTypeWithQualite[] = [ initialManagerStatewithqualities ]
export const initialReducedManagerListStatewithQualities: ReducedManagerTypeWithQuality[] = [ initialReducedManagerTypeWithQualityState ]



// adresse du lieu des oppositions
export const initialOppositionLocationAddressState: oppositionLocationAddress = {
    location: 'Adresse identique au fonds cédé',
    validity: {
        address: '',
        postalCode: '',
        city: ''
    }
};